import { Field, SelectField, StepShell } from "@/components/application-form/Field";

const GENDERS = ["Male", "Female", "Other", "Prefer not to say"];
const CATEGORIES = ["General", "OBC", "SC", "ST", "EWS"];

export function PersonalStep({ values, onChange }) {
  return (
    <StepShell title="Personal Details" description="Tell us a little about yourself.">
      <div className="grid sm:grid-cols-2 gap-5">
        <Field label="Date of Birth" name="dateOfBirth" type="date" value={values.dateOfBirth} onChange={onChange} required testId="apply-dob" />
        <SelectField label="Gender" name="gender" value={values.gender} onChange={onChange} options={GENDERS} required testId="apply-gender" />
      </div>
      <SelectField label="Category" name="category" value={values.category} onChange={onChange} options={CATEGORIES} required testId="apply-category" />
    </StepShell>
  );
}